import React from 'react'

import { useTheme } from '@material-ui/core'

import { Container, StatusBadge } from './index'
import { SupportTicketStatus, SupportTicketTransition } from '../models/types'
import { usePopover } from '../hooks/usePopover'
import { SupportTicketTransitionLogPopover } from './SupportTicketTransitionLogPopover'
import { typographyStyle } from '../theme/typographyStyle'

interface Props {
    status: SupportTicketStatus
    style?: { container?: React.CSSProperties; text?: React.CSSProperties }
    transitions?: SupportTicketTransition[]
    createdDate?: string
    showTransitions?: boolean
}

const getUiStatus = (status: SupportTicketStatus): string => {
    switch (status) {
        case SupportTicketStatus.OPEN:
            return 'Open'
        case SupportTicketStatus.IN_PROGRESS:
            return 'In Progress'
        case SupportTicketStatus.COMPLETE:
            return 'Complete'
        case SupportTicketStatus.PAUSE:
            return 'Paused'
        default:
            return status
    }
}

export const SupportTicketStatusBadge = (props: Props) => {
    const {
        status,
        style,
        transitions,
        createdDate,
        showTransitions = true,
    } = props
    const theme = useTheme()
    const { isOpen, anchorEl, handleOpen, handleClose } = usePopover()

    const text = getUiStatus(status)

    return (
        <Container>
            <StatusBadge
                text={text}
                onClick={
                    showTransitions && transitions
                        ? (e) => {
                              e.stopPropagation()
                              handleOpen(e)
                          }
                        : undefined
                }
                customStyle={{
                    container: {
                        backgroundColor:
                            status === SupportTicketStatus.OPEN
                                ? theme.palette.grey[500]
                                : status === SupportTicketStatus.COMPLETE
                                ? theme.palette.primary.main
                                : status === SupportTicketStatus.IN_PROGRESS
                                ? theme.palette.IN_PROGRESS.main
                                : theme.palette.grey[500],
                        minWidth: 80,
                        cursor:
                            showTransitions && transitions
                                ? 'pointer'
                                : 'default',
                        ...style?.container,
                    },
                    text: {
                        ...typographyStyle(theme.typography.caption),
                        ...style?.text,
                    },
                }}
            />

            {showTransitions && transitions && createdDate && (
                <SupportTicketTransitionLogPopover
                    open={isOpen}
                    anchorEl={anchorEl}
                    closePopover={(e) => {
                        const event = e as any
                        event.stopPropagation()
                        handleClose()
                    }}
                    transitions={transitions}
                    createdDate={createdDate}
                />
            )}
        </Container>
    )
}
